import cn from 'classnames'
import React, { FC, useState, useEffect, useRef, useMemo } from 'react'
import s from './Input.module.css'
import Image from 'next/image'
import Warning from '@components/warning'
import { IField, ILabel } from 'types/Form'
import Label from '../label'
import { stringify } from 'querystring'
import {Logger} from "../../../commons/log";

interface ISelect extends IField {
    required?: boolean,
    name: string,
    id: string,
    type: string,
    className?: string,
    onChange: (value: string) => void,
    label?: Omit<ILabel, "id">
    options: { label: string, value: string }[];
    disabled?: boolean;
}

export const Select: FC<ISelect> = ({ options, className, type, id, required, name, onChange, warning, ready, label, value ,disabled}) => {
    const [value2, setValue] = useState('')
    const [selectedLabel, setSelectedLabel] = useState('')
    const [opened, setOpened] = useState(false);
    const selectRef = useRef<HTMLDivElement>(null);
    const [optionsSatate,setOptionState] = useState<any[]>([]);

    const [fr, setFr] = useState(false);

    useEffect(() => {
        if (fr) {
            onChange(value2);
        }
        setOpened(false);
    }, [value2])

    useEffect(() => {
        if(value2 == '' && value != ""){
            options.forEach(e => {
                if(e.value == value){
                    setOpened(false);
                    setValue(e.value)
                    setSelectedLabel(e.label)
                }
            })
        }
    }, [value])

    const getLabel = () => {
        if(value != '') {
            let label = "";
            for (let i = 0; i < options.length; i++) {
                if(options[i].value == value) {
                    label = options[i].label;
                    break;
                }
            }
            return label;
        }
        return selectedLabel !== '' ? selectedLabel : 'Selecciona uno';
    }

    useEffect(() => {
        setFr(true);
        document.addEventListener('click', (e) => {
            if(disabled) {
                setOpened(false);
            }
            else if (selectRef.current?.contains(e.target as Node)) {
                setOpened(true)
            } else {
                setOpened(false)
            }
        })
        setOptionState(options);
    }, [disabled])

    useEffect(() => {
        let op = options;
        setSelectedLabel('');
        setOptionState(options);
        if(options && options.length == 1){
            const uniqueOption = options[0];
            setSelectedLabel(uniqueOption.label);
            setValue(uniqueOption.value);
        }
    },[options])

    const handleOnClick = (option: any) => { 
        setValue(option.value); 
        setSelectedLabel(option.label);
     }

    return <div className={cn(s.root, className)}>
        {label ? <Label
            {...label}
            id={id}
        /> : null}
        <div ref={selectRef} tabIndex={0}>
            <input className={cn(s.hide)}
                name={name}
                required={required}
                type={type}
                id={id}
                defaultValue={value2}
                disabled={disabled}
            />
            <div className={cn(s.input)}>
                <div className = {cn(s.selectLabel)}>
                    {getLabel()}
                    {!disabled && <Image
                        src="/assets/onboarding/inputs/selector.png"
                        width="11"
                        height="6"
                        layout="fixed"
                    />}
                </div>
                <div className={cn(s.menu, { [s.hide]: !opened })}>
                    {options.map(option => <div
                        key={option.value}
                        className={cn(s.option, { [s.selected]: selectedLabel == option.label })}
                        onClick={() => handleOnClick(option)}
                    >
                        {option.label}
                    </div>)}
                </div>
            </div>
            <Warning warning={warning} />
        </div>
    </div>
}

